export class Category {
	id = null;
	name = null;
	logo = null;

	constructor(data) {
		Object.assign(this, data);
	}

	isSame(category) {
		return this.id == category.id && this.name == category.name && this.logo == category.logo;
	}
}
